// Product page: colour switching, the quantity stepper, the through-the-lens demo and the
// sticky buy bar. The page is rendered by Liquid first; this only updates what the colour changes.
(function () {
  const el = document.getElementById("pdpData");
  if (!el) return;
  const P = JSON.parse(el.textContent);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // what the world looks like through each lens (an illustration, not a measurement)
  const VIEW = {
    grey: ["brightness(.6) contrast(1.08) saturate(.9)", "transparent"],
    dark: ["brightness(.6) contrast(1.08) saturate(.9)", "transparent"],
    brown: ["brightness(.74) contrast(1.16) saturate(1.15) sepia(.28)", "rgba(160,96,40,.34)"],
    gradient: ["brightness(.8) contrast(1.12) saturate(1.1) sepia(.22)", "rgba(160,100,50,.26)"],
    green: ["brightness(.7) contrast(1.1) saturate(.95)", "rgba(92,112,70,.36)"],
    blue: ["brightness(.88) contrast(1.02) saturate(.9)", "rgba(120,160,230,.42)"],
    antiblue: ["brightness(.98) contrast(1.02)", "rgba(255,228,170,.12)"],
    photo: ["brightness(.78) contrast(1.1) saturate(1.05)", "rgba(80,84,88,.2)"],
    polar: ["brightness(.64) contrast(1.32) saturate(1.45)", "rgba(20,32,44,.1)"],
    polarbrown: ["brightness(.72) contrast(1.3) saturate(1.4) sepia(.25)", "rgba(150,90,40,.28)"],
    clear: ["brightness(1) contrast(1)", "transparent"],
  };

  let vi = Math.max(0, P.variants.findIndex((v) => String(v.id) === String($("#varId").value)));
  let qty = 1;

  // every shot of the chosen colour, so switching colour swaps the whole gallery
  function drawGallery(v) {
    const g = $("#gal"), d = $("#galDots");
    if (!g) return;
    g.innerHTML = v.gallery.map((s, i) => `<div class="gal__item${s.m ? " scene" : ""}"><img src="${s.u}" alt="${P.title}, ${v.title}"${i ? ' loading="lazy"' : ""}></div>`).join("");
    g.scrollLeft = 0;
    if (d) d.innerHTML = v.gallery.map((_, i) => `<i class="${i ? "" : "on"}"></i>`).join("");
  }

  function paint() {
    const v = P.variants[vi];
    drawGallery(v);
    $("#price").textContent = v.price;
    $("#vName").textContent = v.title;
    $("#varId").value = v.id;
    $$("#info .sw").forEach((b, i) => { b.classList.toggle("on", i === vi); b.setAttribute("aria-checked", i === vi); });
    $("#lensPill i").style.setProperty("--c", v.tint || "#2a2a2a");
    $("#lensPill span").textContent = v.lens || "";
    const sf = $("#specFrame"), sl = $("#specLens"), ss = $("#specSku");
    if (sf) sf.textContent = v.frame || v.title;
    if (sl) sl.textContent = v.lens || "";
    if (ss) ss.textContent = v.sku || "";
    $("#sbPrice").textContent = `${v.title} · ${v.price}`;

    const stage = $("#viewStage");
    if (stage) {
      const [f, t] = VIEW[v.lensKey] || VIEW.dark;
      $(".view__through img").style.filter = f;
      $(".view__tint").style.background = t;
      $("#thrLbl").textContent = `עם ${P.title} · ${v.lens}`;
      $("#thrLead").textContent = v.lensKey === "antiblue"
        ? "עדשה שקופה כמעט לא משנה את מה שרואים. היא בנויה למסכים, לא לשמש."
        : `טיילת בתל אביב בצהריים, דרך ${v.lens}.`;
    }
    history.replaceState(null, "", `${location.pathname}?variant=${v.id}`);
  }

  $("#info").addEventListener("click", (e) => {
    const sw = e.target.closest(".sw");
    if (sw) { vi = +sw.dataset.i; paint(); }
    const d = e.target.closest("[data-d]");
    if (d) { qty = Math.max(1, Math.min(9, qty + +d.dataset.d)); $("#qty").textContent = qty; $("#qtyInput").value = qty; }
  });

  $("#addForm").addEventListener("submit", (e) => { e.preventDefault(); window.HK.add(P.variants[vi].id, qty); });
  $("#sbAdd").addEventListener("click", () => window.HK.add(P.variants[vi].id, qty));

  // sticky add to cart once the real button scrolls away
  new IntersectionObserver(([e]) => $("#stickyBuy").classList.toggle("on", !e.isIntersecting && e.boundingClientRect.top < 0)).observe($("#add"));

  // gallery dots follow the swipe on a phone
  const gal = $("#gal"), dots = $("#galDots");
  if (gal && dots) {
    dots.innerHTML = $$(".gal__item", gal).map((_, i) => `<i class="${i ? "" : "on"}"></i>`).join("");
    gal.addEventListener("scroll", () => {
      const i = Math.round(Math.abs(gal.scrollLeft) / gal.clientWidth);
      $$("i", dots).forEach((d, j) => d.classList.toggle("on", i === j));
    }, { passive: true });
  }

  // through the lens
  const stage = $("#viewStage");
  if (stage) {
    $(".view__handle span", stage).innerHTML = '<svg viewBox="0 0 24 24"><path d="M8 7l-4 5 4 5M16 7l4 5-4 5"/></svg>';
    const setCut = (pct) => {
      pct = Math.max(4, Math.min(96, pct));
      stage.style.setProperty("--cut", pct + "%");
      $(".view__through", stage).style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
    };
    setCut(55);
    let drag = false;
    const fromE = (e) => { const r = stage.getBoundingClientRect(); setCut(((e.clientX - r.left) / r.width) * 100); };
    stage.addEventListener("pointerdown", (e) => { drag = true; stage.setPointerCapture(e.pointerId); fromE(e); });
    stage.addEventListener("pointermove", (e) => drag && fromE(e));
    stage.addEventListener("pointerup", () => (drag = false));
    const vfit = () => ($("#through .view").style.gridTemplateColumns = innerWidth <= 1100 ? "1fr" : ".8fr 1.4fr");
    addEventListener("resize", vfit);
    vfit();
  }

  paint();
})();
